//const baseURL = 'http://weboa.chinahiron.com:8884/mes/m?xwl=' //saas/
const baseURL = 'https://soa.hironservice.com/mes/saas/api/'
export default {
  baseURL
}



// WEBPACK FOOTER //
// ./src/api/global_variable.js